export default __webpack_public_path__ + "static/media/feature-help-desk-2.63d9e58d.png";